/**
 * KI-Übersetzung TP1 — Lese-Anzeige eines übersetzbaren Felds in der
 * UI-Sprache, mit Badge (Herkunft/Status) und Popover (alle Sprachen,
 * Korrektur mit translations.write).
 */
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getThemeColors } from '../../lib/theme';
import { resolveTranslation, type FieldTranslations, type TranslatableType } from '../../lib/contentTranslations';
import { TranslationBadge, TranslationPopover } from './TranslationPopover';

export interface TranslationTarget { type: TranslatableType; id: number; field: string }

export function TranslatedText({ dark, original, entries, target, onChange }: {
  dark: boolean;
  original: string | null | undefined;
  entries: FieldTranslations | undefined;
  target: TranslationTarget;
  onChange?: (next: FieldTranslations) => void;
}) {
  const t = getThemeColors(dark);
  const { i18n } = useTranslation();
  const [local, setLocal] = useState<FieldTranslations | undefined>(entries);
  const [seen, setSeen] = useState(entries);
  if (seen !== entries) { setSeen(entries); setLocal(entries); }
  const [open, setOpen] = useState(false);
  const r = resolveTranslation(local, i18n.language, original);

  const apply = (next: FieldTranslations) => { setLocal(next); onChange?.(next); };

  return (
    <div style={{ position: 'relative' }}>
      <div style={{ fontSize: 13.5, color: r.text ? t.text : t.muted, whiteSpace: 'pre-wrap', lineHeight: 1.5 }}>
        {r.text || '—'}
      </div>
      <div style={{ marginTop: 4 }}>
        <TranslationBadge dark={dark} resolved={r} onClick={() => setOpen(o => !o)} />
      </div>
      {open && (
        <TranslationPopover
          dark={dark} original={original ?? ''} entries={local} target={target}
          onClose={() => setOpen(false)} onChange={apply}
        />
      )}
    </div>
  );
}
